// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1cgU1","location":"Header_location__3hhCC"};